import { ConsumerCharacterAccessRecord } from 'dynamo-daos';

import { EnhancedGLTF } from '../types';
import apiRequest from './apiRequest';

export type Character = InstanceType<typeof ConsumerCharacterAccessRecord> & {
  heroThumbnailPath: string;
  markerAdjustmentEligible: boolean;
  meshPath: string;
  referenceImagePath?: string;
  thumbnailPath: string;
  vertexCount: number;
  readyOn: Date | null;
  meshData: { current: EnhancedGLTF | null }; // valtio ref<>
};

type ApiResponse = {
  characters: Array<Character>;
};

export default async function getCharacters(
  limit?: number,
  nextToken?: string,
  sortAscending?: boolean,
) {
  const urlParams = new URLSearchParams();
  if (limit) {
    urlParams.set('limit', limit.toString());
  }
  if (nextToken) {
    urlParams.set('nextToken', nextToken);
  }
  if (sortAscending) {
    urlParams.set('sortAscending', sortAscending.toString());
  }

  return apiRequest<ApiResponse>(
    'mogen-orchestration',
    `/characters${urlParams.toString() ? '?' : ''}${urlParams.toString()}`,
  );
}
